import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import POS from "@/pages/POS";
import Tables from "@/pages/Tables";
import Orders from "@/pages/Orders";
import KDS from "@/pages/KDS";
import MenuMgmt from "@/pages/MenuMgmt";
import Inventory from "@/pages/Inventory";
import Employees from "@/pages/Employees";
import Customers from "@/pages/Customers";
import Coupons from "@/pages/Coupons";
import Analytics from "@/pages/Analytics";
import PublicMenu from "@/pages/PublicMenu";
import TableGuest from "@/pages/TableGuest";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Public */}
            <Route path="/" element={<Navigate to="/menu" replace />} />
            <Route path="/menu" element={<PublicMenu />} />
            <Route path="/t/:token" element={<TableGuest />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* App (auth required) */}
            <Route path="/app" element={
              <ProtectedRoute roles={["admin", "manager", "cashier", "kitchen", "waiter"]}>
                <Layout><Dashboard /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/pos" element={
              <ProtectedRoute roles={["admin", "manager", "cashier", "waiter"]}>
                <Layout><POS /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/tables" element={
              <ProtectedRoute roles={["admin", "manager", "cashier", "waiter"]}>
                <Layout><Tables /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/orders" element={
              <ProtectedRoute roles={["admin", "manager", "cashier", "waiter", "kitchen", "customer"]}>
                <Layout><Orders /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/kds" element={
              <ProtectedRoute roles={["admin", "manager", "kitchen"]}>
                <Layout><KDS /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/menu" element={
              <ProtectedRoute roles={["admin", "manager"]}>
                <Layout><MenuMgmt /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/inventory" element={
              <ProtectedRoute roles={["admin", "manager", "kitchen"]}>
                <Layout><Inventory /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/employees" element={
              <ProtectedRoute roles={["admin", "manager"]}>
                <Layout><Employees /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/customers" element={
              <ProtectedRoute roles={["admin", "manager", "cashier"]}>
                <Layout><Customers /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/coupons" element={
              <ProtectedRoute roles={["admin", "manager"]}>
                <Layout><Coupons /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/app/analytics" element={
              <ProtectedRoute roles={["admin", "manager"]}>
                <Layout><Analytics /></Layout>
              </ProtectedRoute>
            } />

            <Route path="*" element={<Navigate to="/menu" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
